export default function buildPatchSingleProducer({
    apiEndpoint,
    apiTools
}) {
    return async function patchSingleProducer(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }`
        })
       
        const res = await fetch(url, {
            method: 'PATCH',
            credentials: 'include',
            body: args.body
        });
        return await res.json();
    }
}